import script from "./CalcPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CalcPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__